<template>

  <v-flex xs12 md6 class="dashboard-intro pa-12" v-if="currentUser.roles.includes('client-manager') === true || currentUser.permissions.create_sub_clients === true">
    <h2 class="whitetext mb-4">Create new client user account</h2>

    <v-form v-model="isValid">
      <v-autocomplete
        v-if="currentUser.roles.includes('client-manager') === true"
        v-model="expClient"
        :items="clientList"
        :loading="isLoading || isLoadingMore"
        :search-input.sync="search"
        :no-data-text="noDataText"
        item-text="name"
        item-value="id"
        label="Client"
        filled
        dense
        solo
        flat
        background-color="white"
        :rules="reqRule"
        required
        @update:search="handleSearch"
        ref="autocomplete"
        class="client-autocomplete"
      >
        <template v-slot:append-item>
          <div
            v-intersect="{
              handler: endIntersect,
              options: {
                threshold: 0.5,
                rootMargin: '0px'
              }
            }"
            style="height: 1px"
          ></div>
        </template>
        <template v-slot:append>
          <v-progress-circular
            v-if="isLoading || isLoadingMore"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </template>
      </v-autocomplete>
      <v-text-field
        label="username"
        v-model="userName"
        prepend-inner-icon="mdi-account-circle"
        solo
        flat
        :rules="reqRule"
        required
      >
      </v-text-field>
      <v-text-field
        label="email address"
        v-model="email"
        prepend-inner-icon="mdi-at"
        solo
        flat
        :rules="emailRules"
        required
      >
      </v-text-field>
      <!-- <v-file-input
        label="Upload a logo"
        v-model="logo"
        solo
        flat
        prepend-inner-icon="mdi-image"
        prepend-icon=""
        clearable
      >
      </v-file-input> -->
      <v-btn
        right
        color="primary"
        class="mt-2"
        :disabled="!isValid"
        @click="createExpClientUser"
      >
        Create account
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-form>
  </v-flex>

</template>

<script>
  import { mapGetters } from "vuex";
  import store from "@/store/"
  import { FETCH_USER, FETCH_EXPCLIENT_LIST, CREATE_EXPCLIENT_USER } from "@/store/actions.type";

  export default {
		name: 'AMDashboardPage',
		data: () => ({
      expClient: null,
      userName: null,
   //   logo: null,
      email: null,
      reqRule:[v => !!v || 'This field is required'],
      emailRules: [
          v => !!v || 'Email is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],

      isValid:true,

      items:  [],
      isLoading: false,
      isLoadingMore: false,
      search: null,
      searchTimeout: null,
      noDataText: "No clients found",
      currentPage: 1,
      lastLoadTime: 0,
      minLoadDelay: 500,
      intersectionDebounceTimeout: null
    }),
    computed: {
      ...mapGetters(["isAuthenticated", "currentUser", "expClientList", "activeExpClient", "hasMorePages"]),
      // fields () {
      //   if (!this.expClientModel) return []

      //   return Object.keys(this.expClientModel).map(key => {
      //     return {
      //       key,
      //       value: this.expClientModel[key] || 'n/a',
      //     }
      //   })
      // },
      clientList() {
        if (!this.expClientList) return []
        return this.expClientList
      },
    },
    watch: {
      search(newVal) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
          this.currentPage = 1;
          this.loadClients(1, newVal);
        }, 300);
      }
    },
    mounted() {
      if (this.currentUser.roles.includes("client-manager") === true) {
        this.loadClients();
      }
    },
    methods: {
      async loadClients(page = 1, search = '') {
        const isInitialLoad = page === 1;
        const loadingState = isInitialLoad ? 'isLoading' : 'isLoadingMore';

        if (this.isLoading || this.isLoadingMore) return;

        this[loadingState] = true;
        try {
          await store.dispatch(FETCH_EXPCLIENT_LIST, {
            userId: this.currentUser.id,
            page,
            search,
            append: page > 1
          });
          this.lastLoadTime = Date.now();
        } catch (error) {
          console.error('Error loading clients:', error);
          this.noDataText = "Error loading clients";
        } finally {
          this[loadingState] = false;
        }
      },
      handleSearch(val) {
        this.search = val;
      },
      endIntersect(isIntersecting) {
        if (this.intersectionDebounceTimeout) {
          clearTimeout(this.intersectionDebounceTimeout);
        }

        this.intersectionDebounceTimeout = setTimeout(() => {
          if (!isIntersecting) return;

          if (!this.hasMorePages || this.isLoading || this.isLoadingMore) return;

          const timeSinceLastLoad = Date.now() - this.lastLoadTime;
          if (timeSinceLastLoad < this.minLoadDelay) return;

          console.log('Intersection detected, loading more clients');
          this.currentPage++;
          this.loadClients(this.currentPage, this.search);
        }, 100);
      },
      createExpClientUser() {
        if(this.isValid){

 if (this.currentUser.roles.includes('client-manager') !== true && this.currentUser.permissions.create_sub_clients === true) {

        this.expClient = this.activeExpClient.id
      console.log(this.expClient);
    }

          let newUser = {
            client_id: this.expClient,
            name: this.userName,
            email: this.email,
          }
          console.log('%cCreateExpClientUser.vue line:114 object', 'color: #007acc;', newUser);
          store.dispatch(CREATE_EXPCLIENT_USER, newUser)
        }
      }
    },
	};
</script>

<style scoped>
.client-autocomplete {
  max-height: 300px;
  overflow-y: auto;
}
</style>

